<div class="start-column-container checkbox-container width-fit-content">
  <label class="row-gap-0p5em clickable"
    [ngClass]="isContentLeft ? 'centered-row-container-flex-start': 'centered-row-container'"
    [class.disabled]="disabled">
    <input
      data-qa="checkbox-input"
      class="checkbox-input clickable"
      type="checkbox"
      [ngModel]="checked"
      (ngModelChange)="onModelChange($event)"
      [disabled]="disabled"/>
      <!-- '-checked' change svg file name
           'checkbox-styling;' , 'disabled;' and  'checked;' are css styles in checkbox.scss -->
      <app-all-icons
        [iconNameAndStyling]="'checkbox' + (minus ? '-minus' : checked ? '-checked' : disabled ? '-disabled' : '') + '.svg;' + checkBoxStyle + ' checkbox-styling;' + (checked ? 'checked;' : '') + (disabled ? 'disabled;' : '')"
      >
      </app-all-icons>
    <ng-content></ng-content>
    <app-all-icons *ngIf="suffixImgAndStyling" [iconNameAndStyling]="suffixImgAndStyling"></app-all-icons>
  </label>
  <div *ngIf="bottomDescription" class="padding-left-1p5 font-3 black-9">{{bottomDescription}}</div>
</div>
